import { Injectable } from '@angular/core';
import {Session, SessionStorageService} from './session-storage.service';
import {BehaviorSubject} from 'rxjs';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public isLoggedIn$ = new BehaviorSubject(false);

  constructor(private sessionStorageService: SessionStorageService) { }

  isAtRenewalThreshold(){
    const session: Session = this.sessionStorageService.getSession();
    const expires = session.exp;
    const delta: number = expires / 10;
    const now = +Date();
  }

  isLoggedIn() {
    const session: Session = this.sessionStorageService.getSession();
    if (!session) { return false; }

    try{
      jwtDecode(session.accessToken);
      return true;
    } catch (e) {
      return false;
    }
  }
}
